var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 9.33333V1.33333H22.6666V3.99999H9.33331V1.33333H1.33331V9.33333H3.99998V22.6667H1.33331V30.6667H9.33331V28H22.6666V30.6667H30.6666V22.6667H28V9.33333H30.6666ZM3.99998 3.99999H6.66665V6.66666H3.99998V3.99999ZM6.66665 28H3.99998V25.3333H6.66665V28ZM22.6666 25.3333H9.33331V22.6667H6.66665V9.33333H9.33331V6.66666H22.6666V9.33333H25.3333V22.6667H22.6666V25.3333ZM28 28H25.3333V25.3333H28V28ZM25.3333 6.66666V3.99999H28V6.66666H25.3333ZM18.3066 18.6667H13.6533L12.68 21.3333H10.52L15.0533 9.33333H16.92L21.4666 21.3333H19.2933L18.3066 18.6667ZM14.2533 16.9867H17.7333L16 11.88L14.2533 16.9867Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.9826fe130d17236070602e3e6cc402e4.svg";
export { ForwardRef as ReactComponent };